import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import Translator from "@/utils/common/Translator.ts";
import {ColDef, ICellRendererParams, ValueFormatterFunc, ValueFormatterParams, ValueGetterFunc} from "ag-grid-community";
import PlaceUtils from "@/utils/common/PlaceUtils.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import EntityTypesUtils from "@/utils/common/EntityTypesUtils.ts";
import AGGridColumnTemplate from "@/utils/UIConstants/AGGridColumns/AGGridColumnTemplate.ts";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";

export default class AGGridIDColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = this.cellRenderer(extraOptions.isReportListView, extraOptions.forSearcher);
    colDef.headerName = this.headerName();
    colDef.valueFormatter = this.valueFormatter();
    colDef.valueGetter = this.valueGetter();
    return colDef;
  }

  private valueFormatter(): ValueFormatterFunc {
    let isCode = this.column.id === "code";
    return (params: ValueFormatterParams) => {
      let value = params.value;
      if (!value)
        return "";
      const code = value.code;
      if (isCode)
        return code;
      const name1 = value.name1;
      const name2 = value.name2;
      if (code && name1 && name2) {
        let name = Translator.getName(name1, name2);
        if (name)
          return name;
        else return code;
      }
      return code;
    }
  };

  private cellRenderer(isReportListView?: boolean, forSearcher?: boolean): any {
    return (params: ICellRendererParams) => {
      let ref = params.value;
      return AGGridColumnTemplate.linkWithBGColorTemplate(params.valueFormatted,
        !isReportListView ? PlaceUtils.linkToObject(ref) : PlaceUtils.linkToReport(ref), ref[CommonFieldIds.COLOR_CODE], forSearcher)
    }
  }

  private headerName(): string | undefined {
    if (this.column.title || !this.column.id || this.column.id.toLowerCase() !== "id")
      return undefined;
    if (EntityTypesUtils.isDocument(this.entityType))
      return Translator.translateId("documentNumber")!;
    else
      return Translator.translateId("name")!;
  }

  private valueGetter(): ValueGetterFunc {
    return params => params.data;
  }
}
